import React from "react";
import ReactDOM from "react-dom/client"; // Notez l'utilisation de 'react-dom/client'
import "./index.css";
import App from "./App";
import 'aos/dist/aos.css'; // Importer les styles
import AOS from 'aos';
import "leaflet/dist/leaflet.css";
import '@fortawesome/fontawesome-free/css/all.min.css';


AOS.init({
    duration: 800, // Durée de l'animation en millisecondes
    easing: 'ease-in-out', // Style d'animation
    once: true, // Animation déclenchée une seule fois
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>
);

